var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"fm-btn",class:_vm.btnClass,attrs:{"href":_vm.href},on:{"click":function($event){$event.stopPropagation();return _vm.clickBtn($event)}}},[_c('div',{staticClass:"fm-btn-wrap"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }